import { ResourcesRequest } from '../ResourcesRequest'
import ResourcesStore from '../ResourcesStore'
import { observable } from 'mobx'

class MoveDocumentStore {
  @observable isLoading = false
  @observable parentFolderId = null
  @observable folders = []
  @observable breadCrumb = []

  getListFolder = async folderId => {
    this.isLoading = true

    let param = {
      id: this.parentFolderId,
      type: 'folder',
    }
    this.isLoading = true

    const response = await ResourcesRequest.search(param)
    this.folders = response.data.data.filter(item => item.id !== folderId)
    this.breadCrumb = response.data?.breadcrumb || []

    this.isLoading = false
  }

  move = async (documentId, folderDestinationId) => {
    this.isLoading = true
    if (folderDestinationId === null) {
      await ResourcesRequest.moveToRoot(documentId)
    } else {
      await ResourcesRequest.move(documentId, folderDestinationId)
    }
    ResourcesStore.search()
    this.isLoading = false
  }

  clearStore = () => {
    this.isLoading = false
    this.folders = []
    this.breadCrumbs = []
    this.parentFolderId = null
  }
}

export default new MoveDocumentStore()
